export const GET_PUBLISHED_VERSIONS = 'GET_PUBLISHED_VERSIONS';
export const GET_PUBLISHED_VERSIONS_SUCCESS = 'GET_PUBLISHED_VERSIONS_SUCCESS';
